"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInstallmentsSelector = void 0;

var _react = require("react");

var _constants = require("../../../constants");

var _hooks = require("../../../hooks");

var _utils = require("../../../utils");

const useInstallmentsSelector = ({
  selectedBy,
  selectedInstallment
}) => {
  const installmentsContainerElement = (0, _hooks.useIsolateTouch)();
  const installmentInfo = (0, _react.useMemo)(() => `${selectedInstallment.installmentsQuantity}x de ${(0, _utils.formatCurrency)(selectedInstallment.installmentsAmount)}`, [selectedInstallment]);
  const monthlyFeeObservations = (0, _react.useMemo)(() => `Com juros a partir de ${(0, _utils.formatPercentage)(selectedInstallment.interestRateMonthly)} ao mês`, [selectedInstallment]);
  (0, _react.useEffect)(() => {
    if (selectedBy === _constants.OrderBy.MAX) {
      const element = installmentsContainerElement.current;
      const {
        width
      } = element.getBoundingClientRect();
      element.scrollLeft = width;
    }
  }, []);
  return {
    installmentsContainerElement,
    installmentInfo,
    monthlyFeeObservations
  };
};

exports.useInstallmentsSelector = useInstallmentsSelector;